export default __webpack_public_path__ + "static/media/image.360-digital-solutions-pvt-ltd.6615bb8e.png";